import axios from 'axios';
import React, { useEffect, useRef, useState } from 'react';
import { Document, Page } from 'react-pdf';
import { pdfjs } from 'react-pdf';
import './PdfViewer.css'
import pdfjsWorker from "react-pdf/node_modules/pdfjs-dist/build/pdf.worker.entry";
import 'react-pdf/dist/esm/Page/AnnotationLayer.css';
import { bucketUrl } from '../../api/api';
import LoaderComponent from '../Loader/Loader';
import ZoomInIcon from '@mui/icons-material/ZoomIn';
import ZoomOutIcon from '@mui/icons-material/ZoomOut';
import InfoToast from '../InfoToast/InfoToast';

// import 'react-pdf/dist/esm/Page/TextLayer.css';

const options = {
    cMapUrl: 'cmaps/',
    cMapPacked: true,
    standardFontDataUrl: 'standard_fonts/',
};

const TextLoader = () => {
    return (
        <div className='loader-cntnr' >
            <div className='pdf-loader-text' >
                <p><b>It will take few seconds to load PDF...</b></p>
            </div>
        </div>
    )
}
const ErrorText = () => {
    return (
        <div className='loader-cntnr' >
            <div className='pdf-loader-text' >
                <p><b>Failed to load PDF file.</b></p>

            </div>
        </div>
    )
}

const INITIAL_ZOOM = 1.5

const PdfViewer = (props) => {
    const [numPages, setNumPages] = useState(null);
    const [pageNumber, setPageNumber] = useState(1);
    const [loading, setLoading] = useState(false)
    const [showPdf, setShowPdf] = useState(false)
    const [err, setErr] = useState(false)
    const [queryParams, setQueryParams] = useState({})
    const [zoom, setZoom] = useState(INITIAL_ZOOM)
    const [showZoomBtn, setShowZoomBtns] = useState(false)
    const [zoomEnabled, setZoomEnabled] = useState(false)
    const [showToast, setShowToast] = useState(false)
    const [toastMsg, setToastMsg] = useState("")


    useEffect(() => {
        pdfjs.GlobalWorkerOptions.workerSrc = pdfjsWorker
        const urlSearchParams = new URLSearchParams(window.location.search);
        const params = Object.fromEntries(urlSearchParams.entries());
        setQueryParams(params)
        setShowPdf(true)
        window.addEventListener('scroll', handleScroll)
        // console.log(document.documentElement.clientWidth)
        // checkTokenValidity()
    }, [])

    const onDocumentLoadSuccess = ({ numPages }) => {
        setNumPages(numPages);
    }

    const handleErr = (err) => {
        console.log("Err : ", err)
    }

    const getAnnotation = (annotation) => {
        //   console.log("ANNO : ",annotation)
    }

    const closeWebview = () => {
        console.log("CLICKED", window.parent)
        if (window.parent) window.parent.postMessage(`http://haptik-webview//perform-action?action=close`, '*');
    }

    const handleZoom = (direction) => {
        handleZoomBtnDisplay()
        if (!showToast) {
            if (direction == "zoomIn") {
                // setZoom((prev) => setZoom(prev + 0.2))
                if (zoom !== 3) {
                    setShowToast(true)
                    setZoom(3)
                    setToastMsg("Zoom in is in progress")
                    setTimeout(() => {
                        setShowToast(false)
                    }, 2000)
                }
            } else {
                // setZoom((prev) => setZoom(prev - 0.2))
                if (zoom !== 1.5) {
                    setShowToast(true)
                    setZoom(1.5)
                    setToastMsg("Zoom Out is in progress")
                    setTimeout(() => {
                        setShowToast(false)
                    }, 2000)
                }
            }
        }
    }


    const handleScroll = (e) => {
        console.log(e)
        handleZoomBtnDisplay()
    }

    const handleZoomBtnDisplay = () => {
        if (!showZoomBtn) {
            setShowZoomBtns(true)
            setTimeout(() => {
                setShowZoomBtns(false)
            }, 4000)
        }
    }


    return (
        <>
            <div className='pdf-viewer'
                onScroll={handleScroll}
                onContextMenu={(e) => { e.preventDefault() }}
            >
                <div className='close-btn'  >
                    {showZoomBtn && <div className='zoom-btns' >
                        <ZoomOutIcon className='zoom-btn' onClick={() => handleZoom("zoomOut")} />
                        <ZoomInIcon className='zoom-btn' onClick={() => handleZoom("zoomIn")} />
                    </div>}
                    <span onClick={closeWebview} >X</span>
                </div>
                {/* <LoaderComponent /> */}
                {showToast && <InfoToast msg={toastMsg} />}
                {loading && <h2>Please wait...</h2>}
                {err && <h2 style={{ color: 'red' }} >Invalid token</h2>}
                {/* {<Document loading={<TextLoader />} error={<ErrorText />} file={"https://arxiv.org/pdf/quant-ph/0410100.pdf"} onLoadError={handleErr} onLoadSuccess={onDocumentLoadSuccess} options={options} width={document.documentElement.clientWidth} > */}
                    { showPdf&&<Document  loading={<TextLoader />} error={<ErrorText />} externalLinkTarget="_blank"  file={`${bucketUrl}bot-files/${queryParams.filename}?token=${queryParams.token}&ssoid=${queryParams.ssoid}`} onLoadError={handleErr} onLoadSuccess={onDocumentLoadSuccess} options={options} >
                    {Array.from({ length: numPages }, (_, i) => i + 1).map((page) => (
                        <Page loading={<LoaderComponent />} onGetAnnotationsSuccess={getAnnotation} key={page} scale={zoom} pageNumber={page} width={document.documentElement.clientWidth} />
                    ))}
                </Document>
                }
            </div>
        </>
    );
}

export default PdfViewer;